module.exports = __webpack_public_path__ + "static/img/5.e4d8d6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/zh/5.png
// module id = MEDl
// module chunks = 0